import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-193" data-mp="3kqw54mwtl6h6">
      <div className="mx-auto max-w-5xl" data-id="element-194" data-mp="3fz5mzurn5ef7">
        <h2 className="text-center font-display text-[1.75rem] font-black leading-tight tracking-tight text-ink sm:text-[2.4rem]" data-id="element-195" data-mp="3fxuly2pkykrs">
          What Professional Instructors Are Saying
        </h2>
        <p className="mt-3 flex items-center justify-center gap-2 text-sm font-medium text-ink/70" data-id="element-196" data-mp="370k9wf4xurlt">
          <span className="flex items-center gap-0.5" aria-hidden="true" data-id="element-197" data-mp="31ybhbjvz9rk8">
            {Array.from({
            length: 5
          }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-amber-500 text-amber-500" data-id="element-198" data-mp="2s1qact0ee6dr" data-mpi={index} />)}
          </span>
          <span data-id="element-199" data-mp="v8nbxaplulim">4.9/5 · +2,000 Instructors</span>
        </p>

        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-200" data-mp="qa3qrciu5drb">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl bg-sand p-6" data-id="element-201" data-mp="h5oox8u9426d">
              <div className="flex items-center gap-0.5" aria-label="5 out of 5 stars" data-id="element-202" data-mp="m6cj23ds0z4t">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-amber-500 text-amber-500" aria-hidden="true" data-id="element-203" data-mp="c73q9dundqk1" data-mpi={index} />)}
              </div>
              <blockquote className="mt-4 flex-1 font-display text-sm italic leading-relaxed text-ink/85" data-id="element-204" data-mp="q6mp1g1kjpjo">
                &ldquo;{item.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6" data-id="element-205" data-mp="v3mrlgz7ma61">
                <p className="text-xs font-bold text-ink" data-id="element-206" data-mp="1iv1y7ly0rdn3">{item.name}</p>
                <p className="text-xs text-ink/50" data-id="element-207" data-mp="1nm0i0vi7utv3">{item.role}</p>
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-8 text-center text-[11px] text-ink/40" data-id="element-208" data-mp="1xgxzjb7do9my">
          Illustrative placeholder testimonials.
        </p>
      </div>
    </section>;
}